import {IBetWinData, IRockBottomData, IRockBottomGameData, IRockBottomInitData} from "./IRockBottomData";
import {IParsedStackedSymbolName, StackedSymbol} from "../../../core/reel/stackedsymbol/StackedSymbol";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {RockBottomGameConfig} from "../../RockBottomGameConfig";
import {IWinRatioConfig} from "../../../core/config/WinRatio";
import {BetWinMode} from "../../../core/config/BetWinMode";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {RockBottom} from "../../RockBottom";
import {RockBottomGameMode} from "../RockBottomGameMode";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";

export class RockBottomDataParser {

    constructor() {

    }

    public parseReels(rawData: IRockBottomData): string[][] {
        return this.parseStackedSymbolsInReels(rawData.reels);
    }

    public parseStackedSymbolsInReels(rawReels: string[][], parsedSymbolNamesUnder?: string[]): string[][] {
        let result: string[][] = [];

        rawReels.forEach((rawReel, reelId) => {
            result.push(this.parseStackedSymbolsInReel(rawReel, reelId, parsedSymbolNamesUnder == null ? undefined : parsedSymbolNamesUnder[reelId]));
        });

        return result;
    }

    // Always start to parse the reel from the bottom because in all cases the bottom of the reel is already known.
    // For special cases like the reel is up side down, please create your own parsing.
    public parseStackedSymbolsInReel(rawReel: string[], reelIndex: number, parsedSymbolNameUnder?: string): string[] {
        const input: string[] = rawReel.concat();
        const result: string[] = [];

        if (parsedSymbolNameUnder == null) {
            let bottomStackedSymName: IParsedStackedSymbolName = StackedSymbol.parseStackedSymbolName(input[input.length - 1], reelIndex);
            // Find out if the reel has half stacked symbols in the bottom
            if (bottomStackedSymName.isStacked) {
                let i: number;
                for (i = 1; i < input.length; i++) {
                    const testStackedSymName: IParsedStackedSymbolName = StackedSymbol.parseStackedSymbolName(input[input.length - 1 - i], reelIndex);
                    if (testStackedSymName.isStacked && testStackedSymName.symName === bottomStackedSymName.symName) {
                        bottomStackedSymName = testStackedSymName;
                    } else {
                        break;
                    }
                }
                // i is the first symbol that's not in the stack.
                i = i % bottomStackedSymName.totalNum; // If num of stacked symbols in the bottom is bigger than stacked.totalNum.
                parsedSymbolNameUnder = `${bottomStackedSymName.symName}*${i.toString()}`;
            } else {
                parsedSymbolNameUnder = "NonStackedDummySym";
            }
        }

        while (input.length > 0) {
            const stackedSymNameUnder: IParsedStackedSymbolName = StackedSymbol.parseStackedSymbolName(result.length > 0 ? result[0] : parsedSymbolNameUnder, reelIndex);
            const stackedSymName: IParsedStackedSymbolName = StackedSymbol.parseStackedSymbolName(input.pop()!, reelIndex);

            // For continue stacked symbol
            if (stackedSymNameUnder.isStacked && stackedSymNameUnder.index > 0) {
                if (!stackedSymName.isStacked || stackedSymName.symName !== stackedSymNameUnder.symName) {
                    debugger;
                    Logger.logDev("If you are using the outcome setter, this might be a case that the outcome made an illegal server data. Please take to the server dev to check if that worth a fix.");
                    throw new Error(`ServerDataParser.parseStackedSymbolsInReel():reelId = ${reelIndex}, reelData = ${rawReel.toString()}, symName = ${stackedSymName.symName}, the symbol should be ${stackedSymName.totalNum}-stacked!`);
                }
                result.unshift(`${stackedSymName.symName}*${(stackedSymNameUnder.index - 1).toString()}`);
                continue;
            }

            // For starting a new stacked symbol
            if (stackedSymName.isStacked) {
                result.unshift(`${stackedSymName.symName}*${(stackedSymName.totalNum - 1).toString()}`);
                continue;
            }

            // For non stacked symbol
            result.unshift(stackedSymName.symName);
        }

        return result;
    }

    public parseScatterPositions(rawData: IRockBottomData): number[] {
        const reelsCount: number = RockBottomGameConfig.REELS_NUM;
        let result = ArrayHelper.initArrayWithValues(reelsCount, reelId => -1);

        for (let reelId: number = 0; reelId < reelsCount; reelId++) {
            if (rawData.reels.length) {
                const reelSet: string[] = (rawData.reels[reelId]).slice(1, -1),
                    symsCount: number = reelSet.length;

                for (let symId: number = 0; symId < symsCount; symId++) {
                    if (reelSet[symId] === "S") {
                        if (result[reelId] === -1) {
                            result[reelId] = symId;
                        } else {
                            debugger;
                            throw new Error(`Server gives more than 1 Scatter on reel ${reelId}!`);
                        }
                    }
                }
            } else {
                result = [-1, -1, -1, -1, -1];
            }
        }

        return result;
    }

    // Game Data:

    public parseBetWins(rawData: IRockBottomGameData | IRockBottomInitData): IBetWinData[] {
        switch (RockBottomGameConfig.BET_WIN_MODE) {
            case BetWinMode.BET_WAY:
                if (rawData.isRestoreState && rawData.mode === RockBottomGameMode.NORMAL && rawData.nextMode === RockBottomGameMode.WINCAP_PICK) {
                    RockBottomGameConfig.BET_WAY_WIN_DATA = rawData.previousbetWayWins!;
                    RockBottomGameConfig.EVALUATED_AREA = this.parseEvaluatedReelData(rawData.reels);
                } else if (rawData.mode === RockBottomGameMode.NORMAL && rawData.nextMode === RockBottomGameMode.WINCAP_PICK) {
                    RockBottomGameConfig.BET_WAY_WIN_DATA = rawData.betWayWins!;
                    RockBottomGameConfig.EVALUATED_AREA = this.parseEvaluatedReelData(rawData.reels);
                } else if (rawData.mode === RockBottomGameMode.WINCAP_PICK && rawData.nextMode === RockBottomGameMode.NORMAL && RockBottomGameConfig.BET_WAY_WIN_DATA.length > 0) {
                    return RockBottomGameConfig.BET_WAY_WIN_DATA;
                } else {
                    //do nothing
                }
                return rawData.betWayWins!;
            default:
                debugger;
                throw new Error("ServerDataParser.parseBetWins(): Invalid BetWinMode from GameConfig!");
        }
    }

    public parseWinRatio(winRatio: number): IWinRatioConfig | null {
        let ratioConfigs: IWinRatioConfig[] = RockBottomGameConfig.WIN_RATIOS;

        let ratioConfig;
        for (let i: number = ratioConfigs.length - 1; i >= 0; i--) {
            const config = ratioConfigs[i];
            if (winRatio >= config.ratio) {
                ratioConfig = config;
                break;
            }
        }

        if (ratioConfig) {
            return {
                ratio: winRatio,
                name: ratioConfig.name,
                duration: ratioConfig.duration,
                bigWinLevel: ratioConfig.bigWinLevel,
                soundName: ratioConfig.soundName,
                endSoundName: ratioConfig.endSoundName
            }
        }
        return null;
    }

    public parseNearWinReels(gameData: IRockBottomGameData, scatterPositions: number[]): boolean[] {
        const result = ArrayHelper.initArrayWithValues(RockBottomGameConfig.REELS_NUM, reelId => false),
            wasFeatureBuy: boolean = gameData.wasFeatureBuy,
            evaluatedReels: string[][] = gameData.evaluatedArea;

        if(RockBottom.apiPlugin.settings.get(APISetting.FAST_SPIN)) {
            return result;
        }

        if (RockBottom.inBonusGame) {
            const activeSymbol: string | null = RockBottom.midSymExpand.getActiveSymbolName();

            if (activeSymbol && evaluatedReels.length > 0) {
                const reel_1: string[] = evaluatedReels[1],
                    reel_2: string[] = evaluatedReels[2];

                result[3] = ((reel_1.includes(activeSymbol) && reel_2.includes(activeSymbol)) ||
                    (reel_1.includes(activeSymbol) && reel_2.includes("S")) ||
                    (reel_1.includes("S") && reel_2.includes(activeSymbol)));

                if (gameData.mode === RockBottomGameMode.SUPER_FREESPIN) {
                    result[3] = reel_1.includes(activeSymbol) || reel_2.includes(activeSymbol);
                }
            }
            return result;
        }

        if (wasFeatureBuy) {
            if (RockBottomGameConfig.IS_LUCKY_DRAW) {
                result[4] = true;
            }
            return result;
        }

        if (!RockBottom.inBonusGame) {
            let scatterCount: number = 0;
            for (let i = 0; i < 5; i++) {
                if (scatterPositions[i] > -1) {
                    scatterCount++;
                }
                if (scatterCount >= 2) {
                    if (i < 4) {
                        result[i + 1] = true;
                    }
                }
            }
        }

        return result;
    }

    public parseNudgeSteps(rawData: IRockBottomGameData | IRockBottomInitData): number[] {
        return ArrayHelper.initArrayWithValues(RockBottomGameConfig.REELS_NUM, reelId => {
            let nudgeSteps: number = 0,
                scatterCount: number = rawData.scatterReels.filter(x => x).length;

            if (scatterCount > 2) {
                for (let i: number = 0; i < RockBottomGameConfig.SYMS_PER_REEL[reelId]; i++) {
                    if (rawData.reels.length) {
                        const reelSet: string[] = (rawData.reels[reelId]).slice(1, -1),
                            symName: string = reelSet[i];

                        if (symName === "S") {
                            nudgeSteps = RockBottomGameConfig.SYMS_PER_REEL[reelId] - i - 1;
                            break;
                        }
                    } else {
                        nudgeSteps = 0;
                    }
                }
            }

            return nudgeSteps;
        });
    }

    private parseEvaluatedReelData(reels: string[][]): string[][] {
        let processedData: string[][] = [];

        for (let reelId: number = 0; reelId < reels.length; reelId++) {
            processedData.push(reels[reelId].slice(1, -1));
        }

        return processedData;
    }
}